interface PaginationProps {
  currentPage: number;
  totalPages: number;
  totalItems: number;
  pageSize: number;
  itemsOnPage: number;
  onPageChange: (page: number) => void;
}

export default function Pagination({
  currentPage,
  totalPages,
  totalItems,
  itemsOnPage,
  onPageChange,
}: PaginationProps) {
  if (totalPages <= 1 && totalItems <= 0) return null;

  return (
    <div className="mt-4 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2">
      <span className="text-[0.75rem] text-text-soft">
        A mostrar {itemsOnPage} de {totalItems} registos · Página {currentPage} de {totalPages}
      </span>
      <div className="flex items-center gap-1.5 sm:gap-2 flex-wrap">
        <button
          type="button"
          onClick={() => onPageChange(Math.max(1, currentPage - 1))}
          disabled={currentPage <= 1}
          className="h-8 sm:h-9 px-2 sm:px-3 rounded-xl border border-border-soft bg-[#0a0b14]/80 text-text text-[0.75rem] sm:text-[0.8rem] disabled:opacity-40 disabled:cursor-not-allowed hover:bg-white/5 transition-colors"
        >
          ← <span className="hidden sm:inline">Anterior</span>
        </button>
        {totalPages <= 7 ? (
          Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
            <button
              key={page}
              type="button"
              onClick={() => onPageChange(page)}
              className={`h-8 w-8 sm:h-9 sm:w-9 rounded-xl border text-[0.75rem] sm:text-[0.8rem] transition-colors ${
                page === currentPage
                  ? 'border-accent bg-accent/20 text-accent font-semibold'
                  : 'border-border-soft bg-[#0a0b14]/80 text-text-soft hover:bg-white/5'
              }`}
            >
              {page}
            </button>
          ))
        ) : (
          <>
            {[1, 2].map((page) => (
              <button
                key={page}
                type="button"
                onClick={() => onPageChange(page)}
                className={`h-8 w-8 sm:h-9 sm:w-9 rounded-xl border text-[0.75rem] sm:text-[0.8rem] transition-colors ${
                  page === currentPage
                    ? 'border-accent bg-accent/20 text-accent font-semibold'
                    : 'border-border-soft bg-[#0a0b14]/80 text-text-soft hover:bg-white/5'
                }`}
              >
                {page}
              </button>
            ))}
            {currentPage > 3 && <span className="text-text-soft text-xs px-1">…</span>}
            {currentPage > 2 && currentPage < totalPages - 1 && (
              <button
                type="button"
                className="h-8 w-8 sm:h-9 sm:w-9 rounded-xl border border-accent bg-accent/20 text-accent font-semibold text-[0.75rem] sm:text-[0.8rem]"
              >
                {currentPage}
              </button>
            )}
            {currentPage < totalPages - 2 && <span className="text-text-soft text-xs px-1">…</span>}
            {[totalPages - 1, totalPages].filter(p => p > 2).map((page) => (
              <button
                key={page}
                type="button"
                onClick={() => onPageChange(page)}
                className={`h-8 w-8 sm:h-9 sm:w-9 rounded-xl border text-[0.75rem] sm:text-[0.8rem] transition-colors ${
                  page === currentPage
                    ? 'border-accent bg-accent/20 text-accent font-semibold'
                    : 'border-border-soft bg-[#0a0b14]/80 text-text-soft hover:bg-white/5'
                }`}
              >
                {page}
              </button>
            ))}
          </>
        )}
        <button
          type="button"
          onClick={() => onPageChange(Math.min(totalPages, currentPage + 1))}
          disabled={currentPage >= totalPages}
          className="h-8 sm:h-9 px-2 sm:px-3 rounded-xl border border-border-soft bg-[#0a0b14]/80 text-text text-[0.75rem] sm:text-[0.8rem] disabled:opacity-40 disabled:cursor-not-allowed hover:bg-white/5 transition-colors"
        >
          <span className="hidden sm:inline">Seguinte</span> →
        </button>
      </div>
    </div>
  );
}
